const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C54AC",
      strokeWidth: 1.0454,
      strokeMiterlimit: 10,
      strokeDasharray: "4.306,4.306"
    },
    d: " M389.104,412.021c-21.155,2.579-42.417-1.755-63.678-2.822c-25.446-1.276-51.18,2.192-75.38,10.159 c-25.658,8.448-49.637,21.894-76.092,27.49c-44.193,9.348-82.751-7.136-112.712-39.588 c-29.962-32.452-40.112-80.953-25.633-122.484c4.929-14.137,12.446-27.397,16.628-41.753 c13.717-47.085-28.605-114.434-3.719-157.094c13.565-23.253,39.619-38.032,66.614-43.24c26.995-5.208,55.743,4.114,82.425,10.253 c25.733,5.92,60.563,16.702,85.597,8.068c17.428-6.011,31.81-13.587,48.435-21.476c35.382-16.789,80.678-4.062,106.484,24.375 c25.806,28.436,33.811,69.215,28.193,106.889c-3.377,22.645-11.264,45.214-8.316,67.861c1.935,14.865,8.441,28.715,12.864,43.053 C487.963,337.293,451.324,404.436,389.104,412.021z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#99DFE3"
    },
    d: "M378.242,399.334c-19.379,2.367-38.854-1.594-58.329-2.564 c-23.309-1.161-46.882,2.021-69.051,9.319c-23.506,7.738-45.475,20.051-69.708,25.179c-40.483,8.568-75.798-6.507-103.234-36.195 c-27.436-29.689-36.719-74.071-23.445-112.081c4.519-12.938,11.409-25.076,15.244-38.214 c12.578-43.093-26.169-104.714-3.361-143.76c12.433-21.284,36.302-34.816,61.031-39.59c24.729-4.774,51.06,3.749,75.499,9.359 c23.569,5.41,55.471,15.267,78.405,7.358c15.966-5.506,29.143-12.443,44.373-19.667c32.415-15.374,73.903-3.741,97.533,22.275 c23.63,26.015,30.951,63.331,25.793,97.809c-3.1,20.724-10.331,41.38-7.637,62.104c1.768,13.603,7.723,26.276,11.771,39.395 C468.82,330.919,435.239,392.375,378.242,399.334z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0999A"
    },
    points: "193.103,315.007 183.236,357.732 137.133,369.495 123.077,363.141 160.617,337.69  165.071,292.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00526D"
    },
    points: "204.163,318.671 298.946,318.671 313.966,375.059 190.081,375.059  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.168,
    y: 368.616,
    style: {
      fill: "#00526D"
    },
    width: 149.486,
    height: 50.211
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M303.431,480.426c0,0,44.381,3.966,73.106,1.263c27.371-2.575,17.829-22.039,10.896-27.24 c-6.934-5.2-21.544-10.896-33.183-10.896c-11.639,0-22.82,7.674-31.697,5.943c-8.877-1.73-13.62-5.943-13.62-5.943 L303.431,480.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M196.2,364.341c-18.261-7.761-63.486-1.863-68.42,29.38c-4.934,31.242,75.66,62.082,92.93,67.839 c17.27,5.757,82.721,18.866,82.721,18.866s8.432-11.995,9.297-21.509c0.865-9.513,1.73-21.188,1.73-21.188 S214.461,372.102,196.2,364.341z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M314.458,437.729c0.108,3.748,0.011,7.497-0.184,11.242c-0.209,3.745-0.533,7.489-1.195,11.208 c-0.611,3.747-2.022,7.336-3.721,10.679c-1.709,3.354-3.676,6.566-5.927,9.567c0.951-1.615,1.889-3.232,2.748-4.891 c0.886-1.643,1.732-3.307,2.492-5.006c1.523-3.399,2.857-6.861,3.434-10.526c0.675-3.649,1.025-7.374,1.413-11.088 C313.87,445.194,314.158,441.465,314.458,437.729z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M350.581,482.627c0.687-1.605,1.056-3.294,1.347-4.975c0.259-1.69,0.383-3.395,0.365-5.103 c-0.001-1.71-0.12-3.421-0.372-5.112c-0.27-1.685-0.615-3.38-1.339-4.969c1.064,1.402,1.694,3.108,2.098,4.82 c0.418,1.721,0.585,3.49,0.603,5.255c-0.001,1.767-0.174,3.543-0.6,5.262C352.254,479.516,351.608,481.201,350.581,482.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M344.927,482.627c0.687-1.605,1.056-3.294,1.347-4.975c0.259-1.69,0.383-3.395,0.365-5.103 c-0.002-1.71-0.12-3.421-0.372-5.112c-0.27-1.685-0.615-3.38-1.339-4.969c1.064,1.402,1.694,3.108,2.098,4.82 c0.419,1.721,0.585,3.49,0.604,5.255c-0.001,1.767-0.174,3.543-0.6,5.262C346.6,479.516,345.954,481.202,344.927,482.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M339.273,482.627c0.687-1.605,1.056-3.294,1.347-4.975c0.258-1.69,0.383-3.395,0.365-5.103 c-0.002-1.71-0.12-3.421-0.372-5.112c-0.27-1.685-0.615-3.38-1.339-4.969c1.064,1.402,1.694,3.108,2.098,4.82 c0.419,1.721,0.584,3.49,0.603,5.255c-0.001,1.767-0.174,3.543-0.6,5.262C340.946,479.516,340.3,481.201,339.273,482.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M333.619,482.627c0.688-1.605,1.056-3.294,1.347-4.975c0.258-1.69,0.382-3.395,0.365-5.103 c-0.002-1.71-0.12-3.421-0.372-5.112c-0.27-1.685-0.615-3.38-1.339-4.969c1.064,1.402,1.694,3.108,2.098,4.82 c0.418,1.721,0.584,3.49,0.603,5.255c-0.001,1.767-0.174,3.543-0.6,5.262C335.292,479.516,334.646,481.202,333.619,482.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M313.789,450.297c3.104,1.441,6.5,2.086,9.871,2.424c1.69,0.179,3.389,0.253,5.088,0.25 c1.706,0.024,3.376-0.118,5.032-0.417c3.304-0.658,6.404-2.045,9.493-3.504c3.088-1.441,6.34-2.821,9.829-3.236 c3.48-0.482,7,0.093,10.314,0.97c3.332,0.882,6.575,2.021,9.741,3.333c6.341,2.598,12.499,5.605,18.456,8.96 c-3.072-1.497-6.159-2.959-9.287-4.327c-3.115-1.393-6.261-2.718-9.447-3.924c-3.189-1.192-6.398-2.347-9.687-3.169 c-3.276-0.835-6.646-1.347-9.966-0.861c-3.333,0.366-6.483,1.66-9.578,3.072c-3.092,1.411-6.287,2.87-9.732,3.432 c-1.713,0.265-3.465,0.363-5.175,0.294c-1.717-0.044-3.434-0.158-5.136-0.394c-1.701-0.237-3.39-0.567-5.042-1.028 C316.913,451.707,315.278,451.143,313.789,450.297z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M196.569,480.426c0,0-44.381,3.966-73.106,1.263c-27.371-2.575-17.829-22.039-10.896-27.24 c6.934-5.2,21.544-10.896,33.183-10.896c11.639,0,22.82,7.674,31.697,5.943c8.877-1.73,13.62-5.943,13.62-5.943L196.569,480.426z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M308.788,361.399c0,0,57.468-6.124,63.432,32.322c4.849,31.256-75.66,62.082-92.93,67.839 c-17.27,5.757-82.721,18.866-82.721,18.866s-8.432-11.995-9.297-21.509c-0.865-9.513-1.73-21.188-1.73-21.188L308.788,361.399z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M320.254,378.458c-10.804,5.824-21.692,11.501-32.714,16.909 c-5.503,2.722-11.042,5.368-16.6,7.979c-5.584,2.554-11.173,5.1-16.84,7.474c-5.66,2.398-11.379,4.637-17.069,6.926 l-17.109,6.794l-34.245,13.525l0.227-0.344c0.075,3.732,0.245,7.471,0.498,11.199c0.273,3.725,0.602,7.454,1.228,11.13 c0.553,3.692,1.881,7.209,3.456,10.594c1.591,3.381,3.435,6.648,5.481,9.781c-2.109-3.092-4.02-6.323-5.686-9.683 c-1.646-3.357-3.064-6.891-3.698-10.611c-0.71-3.693-1.056-7.433-1.38-11.166c-0.295-3.738-0.509-7.477-0.627-11.229 l-0.008-0.25l0.235-0.094l34.17-13.723l17.098-6.829c5.705-2.27,11.424-4.485,17.075-6.854 c11.302-4.754,22.439-9.909,33.515-15.187C298.318,389.475,309.341,384.076,320.254,378.458z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M149.419,482.627c-1.028-1.426-1.673-3.111-2.101-4.822c-0.426-1.719-0.599-3.495-0.6-5.262 c0.019-1.764,0.185-3.533,0.603-5.255c0.404-1.712,1.033-3.418,2.098-4.82c-0.724,1.589-1.069,3.284-1.339,4.969 c-0.252,1.691-0.37,3.402-0.372,5.112c-0.018,1.707,0.106,3.413,0.364,5.103C148.363,479.333,148.732,481.022,149.419,482.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M155.073,482.627c-1.028-1.426-1.674-3.111-2.101-4.822c-0.426-1.719-0.599-3.494-0.6-5.262 c0.019-1.764,0.185-3.533,0.603-5.255c0.404-1.712,1.033-3.418,2.098-4.82c-0.724,1.589-1.069,3.284-1.339,4.969 c-0.252,1.691-0.371,3.402-0.372,5.112c-0.018,1.707,0.106,3.413,0.365,5.103C154.018,479.333,154.386,481.022,155.073,482.627z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M160.727,482.627c-1.027-1.426-1.673-3.111-2.101-4.822c-0.426-1.719-0.599-3.494-0.6-5.262 c0.019-1.764,0.185-3.533,0.603-5.255c0.404-1.712,1.034-3.418,2.098-4.82c-0.724,1.589-1.069,3.284-1.339,4.969 c-0.252,1.691-0.371,3.402-0.372,5.112c-0.018,1.707,0.106,3.413,0.365,5.103C159.672,479.333,160.04,481.022,160.727,482.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M166.382,482.627c-1.028-1.426-1.674-3.111-2.101-4.822c-0.426-1.719-0.599-3.494-0.6-5.262 c0.019-1.764,0.185-3.533,0.604-5.255c0.404-1.712,1.033-3.418,2.098-4.82c-0.724,1.589-1.069,3.284-1.339,4.969 c-0.252,1.691-0.371,3.402-0.372,5.112c-0.018,1.707,0.106,3.413,0.365,5.103C165.326,479.333,165.694,481.022,166.382,482.627z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M186.211,450.297c-1.489,0.846-3.124,1.41-4.772,1.875c-1.653,0.462-3.341,0.791-5.042,1.028 c-1.702,0.236-3.419,0.35-5.136,0.394c-1.71,0.07-3.462-0.028-5.175-0.294c-3.446-0.562-6.64-2.021-9.732-3.432 c-3.095-1.412-6.245-2.707-9.578-3.072c-3.32-0.486-6.691,0.026-9.966,0.861c-3.288,0.822-6.497,1.977-9.687,3.169 c-3.186,1.207-6.332,2.531-9.447,3.924c-3.128,1.368-6.215,2.83-9.287,4.327c5.957-3.355,12.114-6.362,18.456-8.96 c3.166-1.312,6.409-2.451,9.741-3.333c3.314-0.877,6.833-1.452,10.314-0.97c3.49,0.415,6.741,1.795,9.829,3.236 c3.09,1.459,6.189,2.846,9.493,3.504c1.656,0.299,3.326,0.441,5.032,0.417c1.698,0.003,3.398-0.071,5.088-0.25 C179.711,452.383,183.107,451.738,186.211,450.297z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M263.254,406.943c-4.211-3.207-8.445-6.377-12.732-9.474c-4.264-3.126-8.578-6.183-12.942-9.162 c-8.688-6.011-17.589-11.727-26.847-16.763c-4.627-2.514-9.382-4.809-14.322-6.556c-4.95-1.672-10.125-2.8-15.359-3.21 c-5.235-0.432-10.525-0.169-15.715,0.715c-5.182,0.907-10.299,2.42-15.023,4.807c4.609-2.619,9.724-4.279,14.917-5.37 c5.206-1.095,10.571-1.405,15.889-1.092c5.323,0.327,10.604,1.316,15.688,2.991c5.057,1.738,9.882,4.017,14.572,6.51 c4.703,2.475,9.246,5.229,13.706,8.097c4.46,2.87,8.851,5.84,13.166,8.915c4.295,3.104,8.532,6.283,12.717,9.528 C255.127,400.156,259.256,403.472,263.254,406.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M240.042,471.278c7.48-1.776,14.944-3.603,22.376-5.545c7.417-1.982,14.85-3.953,22.075-6.504 c3.617-1.236,7.153-2.728,10.694-4.216l10.58-4.563l21.093-9.311c-6.865,3.463-13.808,6.766-20.796,9.976 c-3.487,1.621-7.011,3.159-10.539,4.691c-3.532,1.514-7.071,3.043-10.721,4.316c-3.644,1.269-7.339,2.353-11.043,3.399 c-3.704,1.044-7.427,2.015-11.167,2.915C255.117,468.234,247.604,469.884,240.042,471.278z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M327.4,359.994"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M271.476,198.953c-1.488-0.865-2.477-1.555-2.806-2.007c-2.924-4.014-3.663-19.851-3.663-19.851 c0.392,0-9.419-0.27-12.526-0.389v-0.056c0,0-0.271,0.01-0.725,0.028c-0.454-0.017-0.725-0.028-0.725-0.028v0.056 c-3.108,0.119-12.918,0.389-12.526,0.389c0,0-0.739,15.837-3.663,19.851c-0.376,0.516-1.609,1.34-3.464,2.383l20.698,14.757 L271.476,198.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M271.476,198.953l-19.401,15.133l-20.698-14.757c-12.589,7.073-54.044,24.254-54.044,24.254 s5.402,35.453,13.168,60.102s13.661,34.986,13.661,34.986s18.776,16.637,47.044,16.637s48.143-16.637,48.143-16.637 s5.895-10.338,13.661-34.986c7.766-24.648,13.168-60.102,13.168-60.102S283.2,205.77,271.476,198.953z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#00526D"
    },
    cx: 250.059,
    cy: 127.982,
    rx: 45.951,
    ry: 43.474
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M289.356,132.778c0,27.106-11.369,55.596-38.59,55.596s-38.59-28.49-38.59-55.596 c0-27.106,17.277-39.497,38.59-39.497C272.079,93.281,289.356,105.672,289.356,132.778z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M230.186,135.539c0.995,1.489,1.993,2.916,3.157,4.086c1.148,1.188,2.51,1.993,3.884,2.017 c0.69-0.013,1.366-0.198,2.023-0.541c0.673-0.326,1.254-0.886,1.846-1.446c1.154-1.174,2.133-2.614,3.11-4.116 c-0.233,1.788-0.868,3.533-1.954,5.072c-0.54,0.773-1.211,1.488-2.063,2.05c-0.855,0.553-1.903,0.89-2.976,0.903 c-1.075-0.022-2.11-0.386-2.955-0.939c-0.849-0.559-1.517-1.272-2.06-2.04C231.104,139.056,230.445,137.323,230.186,135.539z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M260.467,135.539c0.995,1.489,1.993,2.916,3.157,4.086c1.148,1.188,2.51,1.993,3.884,2.017 c0.69-0.013,1.366-0.198,2.023-0.541c0.673-0.326,1.253-0.886,1.846-1.446c1.154-1.174,2.133-2.614,3.11-4.116 c-0.233,1.788-0.868,3.533-1.954,5.072c-0.54,0.773-1.211,1.488-2.064,2.05c-0.854,0.553-1.903,0.89-2.975,0.903 c-1.075-0.022-2.11-0.386-2.955-0.939c-0.849-0.559-1.517-1.272-2.06-2.04C261.385,139.056,260.726,137.323,260.467,135.539z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M226.49,131.186c0.932-1.839,2.212-3.511,3.706-4.978c1.518-1.444,3.269-2.664,5.189-3.584 c1.913-0.906,3.981-1.674,6.139-1.725c2.138-0.064,4.308,0.291,6.199,1.267l-0.043,0.188c-2.095,0.069-4.053,0.161-5.985,0.461 c-1.911,0.312-3.86,0.533-5.709,1.226c-1.842,0.678-3.591,1.661-5.161,2.895c-1.592,1.21-2.989,2.692-4.171,4.351 L226.49,131.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M276.829,131.286c-1.182-1.659-2.579-3.141-4.172-4.351c-1.569-1.234-3.318-2.217-5.16-2.895 c-1.849-0.693-3.797-0.914-5.709-1.226c-1.932-0.3-3.89-0.391-5.985-0.461l-0.043-0.188c1.89-0.976,4.06-1.33,6.199-1.267 c2.159,0.051,4.227,0.82,6.139,1.725c1.919,0.92,3.671,2.141,5.189,3.584c1.495,1.467,2.775,3.139,3.706,4.978L276.829,131.286z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M230.186,181.293c3.278,2.19,6.912,3.662,10.616,4.7c3.728,0.966,7.559,1.48,11.395,1.425 c3.812-0.047,7.607-0.727,11.195-2.071c3.579-1.354,6.998-3.267,9.987-5.838c-1.164,1.608-2.653,2.963-4.23,4.188 c-1.594,1.209-3.329,2.246-5.165,3.079c-1.832,0.844-3.769,1.462-5.744,1.904c-1.982,0.401-4.004,0.644-6.027,0.642 c-4.023,0.019-8.052-0.637-11.842-1.945C236.613,186.02,233.001,184.087,230.186,181.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M252.192,136.431c0.712,1.962,1.318,3.946,1.882,5.94c0.564,1.993,1.078,3.997,1.56,6.008 c0.468,2.014,0.938,4.027,1.333,6.056c0.421,2.024,0.786,4.059,1.133,6.098l0.138,0.812l-0.742,0.125 c-2.883,0.487-5.779,0.915-8.724,1.118c2.757-1.058,5.563-1.891,8.382-2.665l-0.604,0.937c-0.509-2.005-0.998-4.014-1.433-6.035 c-0.46-2.015-0.846-4.046-1.234-6.077c-0.374-2.033-0.715-4.074-1.007-6.125C252.585,140.573,252.336,138.513,252.192,136.431z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M225.605,114.584c0.37-2.929,0.447-6.016-0.76-8.709c-1.207-2.694-4.005-4.862-6.935-4.502 c-2.885,0.354-4.967,2.894-6.465,5.385c-4.897,8.146-6.949,17.966-5.724,27.391c0.329,2.534,1.631,7.958,4.927,8.212 c2.957,0.228,5.898-5.113,7.284-7.205C222.009,129.002,224.68,121.911,225.605,114.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M274.579,114.584c-0.37-2.929-0.447-6.016,0.76-8.709c1.207-2.694,4.005-4.862,6.935-4.502 c2.886,0.354,4.967,2.894,6.465,5.385c4.897,8.146,6.949,17.966,5.724,27.391c-0.329,2.534-1.63,7.958-4.927,8.212 c-2.957,0.228-5.898-5.113-7.284-7.205C278.176,129.002,275.505,121.911,274.579,114.584z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M214.691,138.536c-1.566-2.167-4.489-3.633-7.035-2.721c-1.866,0.669-3.102,2.418-3.892,4.203 c-2.441,5.518-1.414,12.526,3.017,16.69c1.189,1.118,2.663,2.049,4.305,2.186c2.924,0.243,5.528-2.16,6.461-4.883 c0.848-2.474,0.929-5.648,0.043-8.119C216.713,143.445,216.249,140.693,214.691,138.536z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07167"
    },
    d: "M213.156,156.355c-0.946-0.77-1.878-1.806-2.066-3.248c-0.03-0.23-0.038-0.48,0.049-0.692 c0.08-0.196,0.229-0.331,0.374-0.451c0.986-0.815,2.099-1.362,3.241-1.592c-0.112-2.353-0.238-4.777-1.047-6.85 c-0.809-2.074-2.482-3.731-4.31-3.45c-1.429,0.221-2.733,1.695-3.098,3.504c0,0-1.223,3.519,0.454,7.749 C208.429,155.556,213.156,156.355,213.156,156.355z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M206.299,143.576c0.023-0.753,0.218-1.533,0.622-2.227c0.399-0.69,0.984-1.335,1.813-1.698 c0.83-0.389,1.856-0.331,2.684,0.031c0.841,0.353,1.503,0.949,2.031,1.604c1.094,1.32,1.553,2.958,1.852,4.477 c0.242,1.552,0.322,3.076,0.315,4.568l-0.004,0.779l-0.689,0.109c-0.634,0.1-1.261,0.31-1.871,0.589 c-0.303,0.143-0.598,0.311-0.884,0.497l-0.382,0.258c-0.08,0.066-0.096,0.057-0.132,0.142 c-0.067,0.17-0.034,0.564,0.015,0.871c0.049,0.326,0.147,0.651,0.287,0.968c0.276,0.638,0.712,1.239,1.199,1.811 c-0.655-0.365-1.286-0.825-1.777-1.46c-0.243-0.316-0.454-0.67-0.613-1.056c-0.139-0.402-0.28-0.751-0.25-1.319 c0.015-0.284,0.184-0.635,0.365-0.83c0.185-0.21,0.312-0.318,0.468-0.456c0.303-0.263,0.624-0.508,0.966-0.73 c0.679-0.451,1.449-0.785,2.267-0.979l-0.692,0.887c-0.149-1.479-0.217-2.936-0.483-4.319 c-0.224-1.392-0.623-2.702-1.339-3.772c-0.726-1.058-1.781-1.86-2.954-1.585C207.926,141.033,206.85,142.193,206.299,143.576 z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M287.065,138.536c1.566-2.167,4.489-3.633,7.035-2.721c1.866,0.669,3.102,2.418,3.892,4.203 c2.441,5.518,1.414,12.526-3.017,16.69c-1.189,1.118-2.663,2.049-4.306,2.186c-2.924,0.243-5.528-2.16-6.461-4.883 c-0.848-2.474-0.928-5.648-0.043-8.119C285.043,143.445,285.506,140.693,287.065,138.536z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07167"
    },
    d: "M288.599,156.355c0.946-0.77,1.878-1.806,2.066-3.248c0.03-0.23,0.038-0.48-0.049-0.692 c-0.08-0.196-0.229-0.331-0.374-0.451c-0.986-0.815-2.099-1.362-3.24-1.592c0.112-2.353,0.238-4.777,1.047-6.85 c0.808-2.074,2.482-3.731,4.31-3.45c1.429,0.221,2.733,1.695,3.098,3.504c0,0,1.223,3.519-0.454,7.749 C293.326,155.556,288.599,156.355,288.599,156.355z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M295.457,143.576c-0.551-1.383-1.627-2.544-2.816-2.838c-1.173-0.275-2.228,0.527-2.954,1.585 c-0.716,1.07-1.115,2.38-1.339,3.771c-0.267,1.383-0.334,2.84-0.483,4.319l-0.692-0.887c0.818,0.194,1.588,0.528,2.267,0.979 c0.341,0.222,0.663,0.467,0.966,0.73c0.156,0.138,0.283,0.245,0.468,0.456c0.182,0.196,0.35,0.547,0.366,0.83 c0.03,0.569-0.111,0.916-0.25,1.319c-0.159,0.385-0.369,0.739-0.613,1.056c-0.491,0.635-1.122,1.095-1.777,1.46 c0.487-0.572,0.922-1.174,1.198-1.811c0.141-0.317,0.238-0.643,0.288-0.968c0.049-0.308,0.083-0.701,0.016-0.871 c-0.036-0.085-0.052-0.075-0.132-0.142l-0.382-0.258c-0.286-0.187-0.581-0.354-0.884-0.497 c-0.61-0.279-1.237-0.488-1.871-0.589l-0.689-0.109l-0.003-0.779c-0.007-1.492,0.073-3.015,0.315-4.568 c0.299-1.519,0.758-3.157,1.852-4.477c0.529-0.654,1.191-1.251,2.031-1.604c0.828-0.362,1.854-0.42,2.685-0.031 c0.829,0.363,1.413,1.008,1.813,1.698C295.239,142.043,295.433,142.823,295.457,143.576z"
  }))))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#00526D"
    },
    cx: 250.032,
    cy: 103.802,
    rx: 31.227,
    ry: 12.064
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M259.624,91.322c-1.52,0.835-4.504-1.677-6.666-5.612c-2.162-3.934-2.682-7.801-1.162-8.636 c1.52-0.835,4.504,1.677,6.666,5.612C260.623,86.62,261.144,90.487,259.624,91.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M259.3,89.342c-0.833,1.521-4.7,1.007-8.638-1.149c-3.938-2.156-6.455-5.136-5.622-6.658 c0.833-1.521,4.7-1.007,8.638,1.149C257.616,84.84,260.133,87.821,259.3,89.342z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M219.695,205.627c1.74,4.243,3.372,8.524,5.06,12.786l4.885,12.849l-1.079-0.322 c3.785-2.986,7.621-5.905,11.44-8.847l11.513-8.75l0.581-0.441l0.565,0.462l10.95,8.937c3.624,3.011,7.283,5.979,10.877,9.028 l-1.125,0.305l5.247-13.204c1.813-4.377,3.566-8.777,5.432-13.134c-1.469,4.507-3.052,8.97-4.574,13.457l-4.76,13.387 l-0.328,0.923l-0.798-0.617c-3.727-2.885-7.388-5.85-11.083-8.773l-11.01-8.863l1.146,0.02l-11.579,8.662 c-3.878,2.863-7.74,5.748-11.652,8.566l-0.78,0.562l-0.299-0.884l-4.402-13.022C222.514,214.35,221.051,210.008,219.695,205.627z "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00526D"
    },
    points: "243.069,220.644 246.521,230.952 256.4,230.952 259.82,220.644 252.075,214.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00526D"
    },
    points: "246.521,230.952 238.621,310.782 250.526,321.722 263.718,309.817 256.4,230.952  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#91C4FB",
      strokeWidth: 0.9388,
      strokeMiterlimit: 10
    },
    x1: 256.4,
    y1: 230.952,
    x2: 246.521,
    y2: 230.952
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M202.62,325.261c1.207,1.892,2.835,3.477,4.585,4.858c0.862,0.709,1.798,1.326,2.714,1.959 c0.968,0.557,1.889,1.191,2.891,1.684c1.005,0.486,1.966,1.057,2.998,1.483c1.03,0.429,2.051,0.879,3.086,1.291l3.168,1.078 c1.047,0.386,2.149,0.599,3.22,0.906c8.635,2.273,17.609,3.104,26.543,3.077c2.233-0.003,4.466-0.095,6.7-0.138 c1.119,0.003,2.228-0.135,3.341-0.217l3.338-0.279c2.221-0.218,4.418-0.625,6.629-0.928l3.268-0.715l1.637-0.348 c0.543-0.124,1.072-0.302,1.609-0.451l3.209-0.943l3.129-1.178c2.052-0.862,4.075-1.813,5.978-2.975 c0.995-0.513,1.863-1.218,2.798-1.828c0.475-0.297,0.874-0.691,1.314-1.033c0.422-0.364,0.885-0.685,1.269-1.091 c1.645-1.503,3.123-3.235,4.12-5.247c-0.927,2.046-2.355,3.842-3.961,5.412c-0.374,0.424-0.828,0.762-1.241,1.144 c-0.432,0.36-0.825,0.773-1.292,1.089c-0.92,0.648-1.779,1.393-2.765,1.945c-1.899,1.22-3.93,2.217-5.99,3.131l-3.143,1.253 c-1.069,0.355-2.15,0.676-3.225,1.016c-0.54,0.161-1.073,0.351-1.62,0.487l-1.646,0.383l-3.298,0.746 c-2.228,0.321-4.446,0.745-6.684,0.98l-3.363,0.303c-1.122,0.09-2.241,0.236-3.367,0.24c-2.249,0.057-4.498,0.166-6.747,0.179 c-8.984-0.051-18.04-0.874-26.729-3.322c-1.077-0.332-2.182-0.567-3.234-0.978l-3.179-1.15c-1.039-0.437-2.063-0.911-3.093-1.364 c-1.032-0.452-2-1.041-2.998-1.561c-0.993-0.532-1.906-1.204-2.86-1.799c-0.904-0.671-1.824-1.324-2.669-2.067 C205.345,328.846,203.763,327.195,202.62,325.261z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#99DFE3",
      strokeWidth: 0.9388,
      strokeMiterlimit: 10
    },
    d: "M252.327,342.079v34.929l0,0 c4.413,0,7.991-3.578,7.991-7.991v-26.938"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 1.8626,
      strokeMiterlimit: 10
    },
    d: "M269.149,247.105 c0,0,10.916,1.904,22.318,0.959c11.402-0.945,18.732-3.45,18.732-3.45l-0.091,5.154c0,0-7.7,2.709-19.102,3.654 c-11.402,0.945-22.318-0.959-22.318-0.959L269.149,247.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M177.333,223.583l-27.831,68.802c0,0,10.796,12.674,22.062,17.368 c11.266,4.694,21.539,5.254,21.539,5.254l8.827-37.629L177.333,223.583z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M204.163,318.671c-3.241-6.377-6.131-12.932-8.743-19.597c-2.604-6.668-4.953-13.445-6.894-20.354 c-1.902-6.918-3.499-13.897-4.811-20.936c-1.32-7.034-2.361-14.123-2.975-21.251c1.33,7.025,2.845,13.999,4.398,20.956 c1.595,6.946,3.264,13.882,5.18,20.729c0.939,3.428,1.983,6.83,3.075,10.218c1.055,3.401,2.243,6.759,3.385,10.135 C199.149,305.293,201.58,312.003,204.163,318.671z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M123.589,362.826c0,0-3.129,3.256-5.534,8.83c-2.406,5.574-5.099,17.5-5.099,17.5 c-1.734,8.244-2.656,16.936-0.787,25.151c0.108,0.475,0.232,0.963,0.528,1.35c0.296,0.387,0.809,0.65,1.275,0.51 c0.59-0.177,0.837-0.865,0.966-1.468c0.614-2.886,0.433-5.873,0.53-8.822c0.164-4.94,1.117-9.815,2.082-14.663 c-0.521,6.94,0.068,13.749,1.847,20.477c0.412,1.559,0.902,3.137,1.868,4.427c0.305,0.408,0.789,0.819,1.267,0.645 c0.314-0.115,0.49-0.444,0.615-0.754c0.737-1.831,0.689-3.869,0.66-5.842c-0.09-6.217,0.128-12.438,0.653-18.634 c-0.406,5.143,0.857,10.003,1.777,15.08c0.528,2.914,1.094,5.876,2.484,8.491c0.223,0.419,0.543,0.878,1.018,0.9 c0.648,0.03,0.999-0.74,1.136-1.374c0.513-2.385,0.533-4.846,0.55-7.285c0.039-5.359,0.078-10.719,0.117-16.078 c0.605,6.307,1.186,12.19,3.63,18.036c0.223,0.533,0.517,1.114,1.064,1.298c0.599,0.201,1.269-0.189,1.591-0.732 c0.322-0.543,0.378-1.199,0.414-1.829c0.403-7.016-0.658-14.043-0.463-21.068c0.183-6.599,1.116-13.12,1.814-19.221 l-1.292-0.398L123.589,362.826z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M138.849,369.452c0.152-1.223,1.781-1.551,2.381-0.474c1.808,3.241,4.195,8.415,3.931,12.761 c-0.298,4.922-1.5,10.8-2.166,13.775c-0.233,1.038-1.542,1.34-2.234,0.532c-1.052-1.227-2.126-3.416-1.844-7.139 c0.422-5.573-0.678-8.386-1.119-9.266c-0.113-0.225-0.154-0.472-0.123-0.722L138.849,369.452z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0999A"
    },
    points: "308.083,315.007 317.949,357.732 364.053,369.495 378.109,363.141 340.568,337.69  336.114,292.832  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M326.172,223.603l25.511,68.782c0,0-10.796,12.674-22.062,17.368 c-11.266,4.694-21.539,5.254-21.539,5.254l-8.827-37.629L326.172,223.603z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M377.597,362.826c0,0,3.129,3.256,5.534,8.83c2.406,5.574,5.099,17.5,5.099,17.5 c1.734,8.244,2.656,16.936,0.787,25.151c-0.108,0.475-0.232,0.963-0.528,1.35c-0.296,0.387-0.809,0.65-1.275,0.51 c-0.59-0.177-0.837-0.865-0.966-1.468c-0.614-2.886-0.433-5.873-0.53-8.822c-0.164-4.94-1.117-9.815-2.082-14.663 c0.521,6.94-0.068,13.749-1.847,20.477c-0.412,1.559-0.902,3.137-1.868,4.427c-0.305,0.408-0.789,0.819-1.267,0.645 c-0.314-0.115-0.49-0.444-0.615-0.754c-0.737-1.831-0.689-3.869-0.66-5.842c0.09-6.217-0.128-12.438-0.653-18.634 c0.406,5.143-0.857,10.003-1.777,15.08c-0.528,2.914-1.094,5.876-2.484,8.491c-0.223,0.419-0.543,0.878-1.018,0.9 c-0.648,0.03-0.999-0.74-1.136-1.374c-0.513-2.385-0.533-4.846-0.551-7.285c-0.039-5.359-0.078-10.719-0.117-16.078 c-0.605,6.307-1.186,12.19-3.63,18.036c-0.223,0.533-0.517,1.114-1.064,1.298c-0.599,0.201-1.269-0.189-1.591-0.732 c-0.322-0.543-0.378-1.199-0.414-1.829c-0.403-7.016,0.657-14.043,0.463-21.068c-0.182-6.599-1.116-13.12-1.814-19.221 l1.292-0.398L377.597,362.826z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0999A"
    },
    d: "M362.336,369.452c-0.152-1.223-1.781-1.551-2.381-0.474c-1.808,3.241-4.195,8.415-3.931,12.761 c0.298,4.922,1.5,10.8,2.166,13.775c0.233,1.038,1.542,1.34,2.234,0.532c1.051-1.227,2.126-3.416,1.844-7.139 c-0.422-5.573,0.678-8.386,1.119-9.266c0.113-0.225,0.154-0.472,0.123-0.722L362.336,369.452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M299.087,318.671c2.582-6.668,5.013-13.378,7.385-20.099c1.142-3.376,2.33-6.735,3.385-10.135 c1.092-3.388,2.136-6.79,3.075-10.218c1.917-6.847,3.586-13.783,5.18-20.729c1.553-6.958,3.068-13.931,4.398-20.956 c-0.614,7.127-1.655,14.217-2.975,21.251c-1.312,7.039-2.909,14.018-4.811,20.936c-1.941,6.909-4.29,13.686-6.894,20.354 C305.218,305.739,302.328,312.294,299.087,318.671z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07167"
    },
    d: "M249.16,173.739c0.629,0.754,2.183,1.29,4.012,1.29c1.715,0,3.184-0.474,3.88-1.154 c-0.887-0.474-2.142-0.873-3.88-0.873C251.412,173.001,250.102,173.34,249.16,173.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M257.488,173.001c0-1.12-1.932-2.027-4.316-2.027c-2.384,0-4.316,0.908-4.316,2.027 c0,0.261,0.114,0.508,0.305,0.738c0.942-0.399,2.251-0.738,4.012-0.738c1.738,0,2.993,0.399,3.88,0.873 C257.323,173.609,257.488,173.316,257.488,173.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M307.443,310.874c4.099-0.665,8.078-1.737,11.947-3.06c3.842-1.391,7.592-3.025,11.059-5.142 c1.728-1.045,3.44-2.189,5.107-3.384c1.697-1.155,3.311-2.42,4.941-3.668c3.204-2.56,6.337-5.237,9.099-8.336 c-2.149,3.58-5.081,6.639-8.161,9.447c-3.12,2.798-6.437,5.306-10.027,7.538c-3.624,2.169-7.549,3.789-11.584,4.928 C315.779,310.289,311.609,310.978,307.443,310.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M193.529,310.874c-4.167,0.104-8.336-0.586-12.379-1.678c-4.035-1.139-7.96-2.759-11.584-4.928 c-3.59-2.232-6.907-4.74-10.027-7.538c-3.08-2.808-6.012-5.867-8.161-9.447c2.761,3.1,5.894,5.776,9.098,8.336 c1.63,1.248,3.244,2.513,4.941,3.668c1.666,1.196,3.378,2.339,5.106,3.384c3.466,2.117,7.217,3.752,11.059,5.142 C185.451,309.137,189.43,310.209,193.529,310.874z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M357.711,28.485l-9.503,5.493l-51.873-8.942c-1.362-0.235-2.656,0.679-2.891,2.041l-8.792,51.005 c-0.235,1.362,0.679,2.656,2.041,2.891l75.224,12.967c1.362,0.235,2.656-0.679,2.891-2.04l9.217-53.47l0.769-4.459 c0.235-1.362-0.679-2.656-2.041-2.891L357.711,28.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081A7"
    },
    d: "M365.006,34.945l-10.307,4.781l-51.873-8.942c-1.362-0.235-2.784,0.565-3.177,1.787 l-14.711,45.763c-0.393,1.222,0.393,2.403,1.754,2.637l75.224,12.967c1.362,0.235,2.784-0.565,3.177-1.787l15.422-47.975 l1.286-4.001c0.393-1.222-0.393-2.403-1.754-2.637L365.006,34.945z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.044,
    y: 201.568,
    transform: "matrix(0.9579 0.2872 -0.2872 0.9579 69.3576 -20.6727)",
    style: {
      fill: "#00AFB9"
    },
    width: 74.174,
    height: 48.926
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00526D"
    },
    points: "76.633,191.946 103.804,230.453 147.681,213.252  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AFB9"
    },
    points: "183.659,60.533 152.587,65.164 146.863,26.758 185.268,21.034 189.899,52.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC5B7"
    },
    points: "183.659,60.533 182.566,53.2 189.899,52.107  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0081A7"
    },
    points: "188.803,87.165 159.006,77.211 171.309,40.382 208.138,52.685 198.184,82.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00526D"
    },
    points: "188.803,87.165 191.152,80.133 198.184,82.482  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AFB9"
    },
    d: "M476.569,141.666c0,6.483-1.46,13.002-4.275,18.844l-2.173,4.56l-19.022-19.164l0.356-1.817 c0.107-0.712,0.178-1.532,0.178-2.422c0-7.659-4.773-14.462-11.862-16.92l-2.387-0.855V98.529l4.203,0.784 C461.857,103.052,476.569,120.863,476.569,141.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081A7"
    },
    d: "M447.146,153.919l17.597,17.739l-2.85,2.494c-7.765,6.804-17.739,10.58-28.069,10.58 s-20.304-3.776-28.07-10.58l-2.85-2.494l17.597-17.739l2.493,1.995c6.163,4.88,15.495,4.88,21.658,0L447.146,153.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00526D"
    },
    d: "M426.058,99.312l4.203-0.784v25.362l-2.387,0.855c-7.089,2.458-11.862,9.261-11.862,16.92 c0,0.891,0.071,1.71,0.178,2.422l0.356,1.817l-19.022,19.164l-2.173-4.56c-2.814-5.842-4.275-12.361-4.275-18.844 C391.078,120.863,405.789,103.052,426.058,99.312z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M364.311,268.379c0,0,13.702-7.902,23.164-27.725c9.462-19.824,10.362-36.327,10.362-36.327 l47.509,17.503c0,0-0.9,16.503-10.362,36.327c-9.462,19.824-23.405,29.287-23.405,29.287L364.311,268.379z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 402.228,
    y1: 211.329,
    x2: 441.147,
    y2: 226.334
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 400.807,
    y1: 216.06,
    x2: 439.726,
    y2: 231.065
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 399.576,
    y1: 220.794,
    x2: 438.495,
    y2: 235.799
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 398.349,
    y1: 225.339,
    x2: 437.268,
    y2: 240.343
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 397.118,
    y1: 230.073,
    x2: 436.037,
    y2: 245.077
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 395.015,
    y1: 234.791,
    x2: 433.934,
    y2: 249.795
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 392.421,
    y1: 239.499,
    x2: 431.34,
    y2: 254.504
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 389.831,
    y1: 244.018,
    x2: 428.75,
    y2: 259.022
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 386.717,
    y1: 248.503,
    x2: 425.636,
    y2: 263.508
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 384.076,
    y1: 252.648,
    x2: 422.995,
    y2: 267.653
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 380.968,
    y1: 256.784,
    x2: 419.887,
    y2: 271.789
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 378.208,
    y1: 261.043,
    x2: 417.127,
    y2: 276.048
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.6817,
      strokeMiterlimit: 10
    },
    x1: 374.631,
    y1: 265.404,
    x2: 413.55,
    y2: 280.408
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M143.953,139.37c0,0-18.269-10.534-30.883-36.964c-12.615-26.429-13.815-48.432-13.815-48.432 L35.916,77.31c0,0,1.2,22.002,13.814,48.432c12.615,26.429,31.204,39.046,31.204,39.046L143.953,139.37z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 93.402,
    y1: 63.31,
    x2: 41.515,
    y2: 83.315
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 95.297,
    y1: 69.617,
    x2: 43.409,
    y2: 89.622
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 96.938,
    y1: 75.929,
    x2: 45.05,
    y2: 95.934
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 98.574,
    y1: 81.988,
    x2: 46.686,
    y2: 101.992
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 100.215,
    y1: 88.299,
    x2: 48.327,
    y2: 108.304
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 103.018,
    y1: 94.589,
    x2: 51.131,
    y2: 114.593
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 106.477,
    y1: 100.867,
    x2: 54.589,
    y2: 120.871
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 109.93,
    y1: 106.891,
    x2: 58.043,
    y2: 126.895
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 114.082,
    y1: 112.871,
    x2: 62.194,
    y2: 132.875
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 117.603,
    y1: 118.397,
    x2: 65.715,
    y2: 138.402
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 121.746,
    y1: 123.912,
    x2: 69.858,
    y2: 143.916
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 125.425,
    y1: 129.59,
    x2: 73.538,
    y2: 149.594
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00526D",
      strokeWidth: 0.9089,
      strokeMiterlimit: 10
    },
    x1: 130.195,
    y1: 135.403,
    x2: 78.307,
    y2: 155.408
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99DFE3"
    },
    points: "357.902,183.729 360.979,191.166 367.682,193.51 360.636,195.858 357.902,203.291  355.257,196.545 348.121,193.51 354.685,191.166  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M329.83,170.803c-0.79-2.226-1.2-4.451-1.495-6.677c-0.28-2.225-0.41-4.451-0.412-6.676 c-0.003-2.225,0.128-4.451,0.407-6.676c0.294-2.225,0.705-4.451,1.5-6.676c0.795,2.226,1.206,4.451,1.5,6.676 c0.279,2.225,0.41,4.451,0.407,6.676c-0.002,2.225-0.133,4.451-0.412,6.676C331.03,166.352,330.621,168.577,329.83,170.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M343.182,157.451c-2.225,0.79-4.451,1.2-6.676,1.495c-2.225,0.28-4.451,0.41-6.676,0.412 c-2.225,0.003-4.451-0.127-6.676-0.407c-2.225-0.294-4.451-0.705-6.676-1.5c2.225-0.795,4.451-1.206,6.676-1.5 c2.225-0.28,4.45-0.41,6.676-0.407c2.225,0.002,4.451,0.132,6.676,0.412C338.732,156.251,340.957,156.661,343.182,157.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M320.389,166.892c1.015-2.132,2.299-3.996,3.664-5.778c1.376-1.771,2.857-3.437,4.429-5.012 c1.571-1.576,3.237-3.057,5.008-4.433c1.781-1.366,3.646-2.649,5.781-3.66c-1.012,2.136-2.294,4-3.66,5.781 c-1.376,1.771-2.857,3.437-4.433,5.009c-1.575,1.572-3.241,3.053-5.012,4.429C324.384,164.594,322.521,165.877,320.389,166.892 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M339.272,166.892c-2.132-1.015-3.996-2.299-5.778-3.664c-1.771-1.376-3.437-2.857-5.012-4.429 c-1.576-1.572-3.057-3.237-4.433-5.009c-1.366-1.781-2.648-3.645-3.66-5.781c2.136,1.011,4,2.294,5.781,3.66 c1.772,1.376,3.437,2.857,5.009,4.433c1.572,1.575,3.053,3.241,4.429,5.012C336.973,162.896,338.257,164.76,339.272,166.892z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M358.095,133.864c-0.422-1.189-0.641-2.378-0.799-3.566c-0.149-1.189-0.219-2.378-0.22-3.567 c-0.001-1.189,0.068-2.378,0.217-3.566c0.157-1.189,0.377-2.378,0.801-3.567c0.425,1.189,0.644,2.378,0.801,3.567 c0.149,1.188,0.219,2.377,0.217,3.566c-0.001,1.188-0.071,2.378-0.22,3.567C358.736,131.486,358.517,132.675,358.095,133.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M365.228,126.731c-1.189,0.422-2.378,0.641-3.566,0.798c-1.189,0.149-2.378,0.219-3.566,0.22 c-1.189,0.002-2.378-0.068-3.566-0.217c-1.189-0.157-2.378-0.377-3.566-0.801c1.189-0.425,2.378-0.644,3.566-0.801 c1.189-0.149,2.377-0.219,3.566-0.217c1.189,0.001,2.378,0.071,3.566,0.22C362.85,126.09,364.039,126.309,365.228,126.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M353.051,131.775c0.542-1.139,1.228-2.134,1.957-3.087c0.735-0.946,1.526-1.836,2.366-2.677 c0.839-0.842,1.729-1.633,2.676-2.368c0.952-0.729,1.948-1.415,3.088-1.955c-0.54,1.141-1.225,2.137-1.955,3.089 c-0.735,0.946-1.526,1.836-2.368,2.676c-0.841,0.839-1.731,1.631-2.678,2.366C355.186,130.547,354.19,131.233,353.051,131.775z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M363.138,131.775c-1.139-0.542-2.134-1.228-3.087-1.957c-0.946-0.735-1.836-1.527-2.677-2.366 c-0.842-0.84-1.633-1.73-2.368-2.676c-0.73-0.952-1.415-1.947-1.955-3.089c1.141,0.54,2.137,1.226,3.088,1.955 c0.947,0.735,1.836,1.526,2.676,2.368c0.84,0.841,1.631,1.731,2.366,2.677C361.911,129.641,362.596,130.636,363.138,131.775z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99DFE3"
    },
    points: "194.651,164.438 186.174,160.93 183.501,153.288 180.824,161.321 172.351,164.438  180.042,167.453 183.501,175.588 186.174,168.105  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M126.805,180.649c1.739,0.617,3.477,0.937,5.215,1.167c1.738,0.219,3.476,0.32,5.214,0.322 c1.738,0.002,3.477-0.1,5.215-0.318c1.738-0.23,3.477-0.551,5.215-1.172c-1.738-0.621-3.477-0.942-5.215-1.172 c-1.738-0.218-3.476-0.32-5.215-0.318c-1.738,0.002-3.476,0.104-5.214,0.322C130.281,179.712,128.543,180.032,126.805,180.649z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M137.234,170.219c-0.617,1.738-0.937,3.476-1.167,5.215c-0.219,1.738-0.32,3.476-0.322,5.214 c-0.003,1.738,0.099,3.476,0.318,5.215c0.229,1.738,0.551,3.476,1.171,5.215c0.621-1.738,0.942-3.477,1.172-5.215 c0.218-1.738,0.32-3.476,0.318-5.215c-0.002-1.738-0.104-3.476-0.322-5.214C138.171,173.696,137.852,171.958,137.234,170.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M129.86,188.023c1.666-0.793,3.121-1.795,4.513-2.862c1.384-1.074,2.685-2.232,3.915-3.46 c1.231-1.227,2.388-2.529,3.462-3.912c1.067-1.391,2.069-2.847,2.859-4.516c-1.668,0.79-3.124,1.792-4.516,2.859 c-1.384,1.075-2.685,2.232-3.912,3.462c-1.228,1.23-2.385,2.531-3.46,3.915C131.655,184.902,130.652,186.358,129.86,188.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M129.86,173.274c0.793,1.666,1.796,3.121,2.862,4.513c1.075,1.384,2.232,2.685,3.46,3.915 c1.227,1.231,2.529,2.388,3.912,3.463c1.391,1.067,2.847,2.069,4.516,2.859c-0.79-1.668-1.792-3.124-2.859-4.515 c-1.075-1.384-2.232-2.685-3.462-3.912c-1.23-1.228-2.531-2.385-3.915-3.46C132.981,175.07,131.525,174.067,129.86,173.274z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M159.048,118.092c1.057,0.376,2.114,0.57,3.171,0.71c1.057,0.133,2.115,0.195,3.171,0.196 c1.057,0.001,2.114-0.061,3.171-0.193c1.057-0.14,2.114-0.335,3.171-0.713c-1.057-0.378-2.114-0.573-3.171-0.712 c-1.057-0.133-2.114-0.195-3.171-0.193c-1.057,0.001-2.114,0.063-3.171,0.196C161.162,117.522,160.105,117.716,159.048,118.092 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M165.391,111.75c-0.375,1.057-0.57,2.114-0.71,3.171c-0.133,1.057-0.195,2.114-0.196,3.171 c-0.002,1.057,0.061,2.114,0.193,3.171c0.14,1.057,0.335,2.114,0.713,3.171c0.378-1.057,0.573-2.114,0.713-3.171 c0.132-1.057,0.195-2.114,0.193-3.171c-0.001-1.057-0.063-2.114-0.196-3.171C165.96,113.864,165.766,112.807,165.391,111.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M160.906,122.576c1.013-0.482,1.898-1.092,2.744-1.74c0.841-0.653,1.633-1.357,2.381-2.104 c0.749-0.746,1.452-1.538,2.106-2.379c0.649-0.846,1.258-1.732,1.739-2.746c-1.015,0.48-1.9,1.09-2.746,1.738 c-0.841,0.654-1.633,1.357-2.379,2.106c-0.746,0.748-1.45,1.539-2.104,2.381C161.998,120.678,161.388,121.563,160.906,122.576z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99DFE3"
    },
    d: "M160.906,113.607c0.482,1.013,1.092,1.898,1.74,2.744c0.654,0.841,1.357,1.632,2.104,2.381 c0.747,0.749,1.538,1.452,2.379,2.106c0.846,0.649,1.732,1.258,2.746,1.738c-0.481-1.015-1.09-1.9-1.739-2.746 c-0.654-0.842-1.357-1.633-2.106-2.379c-0.748-0.747-1.539-1.45-2.381-2.104C162.804,114.699,161.919,114.089,160.906,113.607z "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.543511a47179dfb1b4f07813921c982c.svg";
export { ForwardRef as ReactComponent };